import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0621f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Thêm mới ")
const _hoisted_9 = { class: "card-body p-5" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table table-row-dashed table-row-gray-300 table-striped border align-middle gs-0 gy-4" }
const _hoisted_12 = { class: "fw-bolder text-dark fs-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "w-75px text-center" }, "Stt", -1))
const _hoisted_14 = { class: "min-w-150px" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Quyền ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px text-end" }, "Module", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px pe-5 text-end" }, "Hành động", -1))
const _hoisted_18 = { class: "w-75px text-center" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_21 = { class: "text-muted fw-bold text-end" }
const _hoisted_22 = { class: "text-end pe-5" }
const _hoisted_23 = { class: "svg-icon svg-icon-3" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "svg-icon svg-icon-3" }
const _hoisted_26 = { class: "card-footer pt-3" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-2" }
const _hoisted_29 = ["value", "selected"]
const _hoisted_30 = { class: "col-10 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen004.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "data-kt-customer-table-filter": "search",
            class: "form-control form-control-solid w-250px ps-15",
            placeholder: "Tìm kiếm...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.params.name]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ms-1 me-3",
            "data-kt-menu-trigger": "click",
            "data-kt-menu-placement": "bottom-end",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
          }, " Tìm kiếm ")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/administrators/permissions/add",
          class: "btn btn-primary",
          "data-kt-menu-trigger": "click",
          "data-kt-menu-placement": "bottom-end",
          "data-kt-menu-flip": "top-end"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" }),
              _hoisted_8
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("th", _hoisted_14, [
                _createElementVNode("a", {
                  class: "text-primary",
                  href: "javascript:void(0)",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickSort('name')))
                }, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("i", {
                    class: _normalizeClass(["fa", {
                      'fa-sort-amount-down': _ctx.params.order === 'desc',
                      'fa-sort-amount-up': _ctx.params.order === 'asc',
                    }])
                  }, null, 2), [
                    [_vShow, _ctx.params.order_by === 'name']
                  ])
                ])
              ]),
              _hoisted_16,
              _hoisted_17
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_18, _toDisplayString(index + 1 + (_ctx.page - 1) * _ctx.limit), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_21, _toDisplayString(item.module), 1),
                _createElementVNode("td", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: 'permissions/edit/' + item._id,
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.onClickDelete(item._id)),
                    class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                  }, [
                    _createElementVNode("span", _hoisted_25, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                    ])
                  ], 8, _hoisted_24)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("select", {
            class: "form-select",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeLimit($event)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitData, (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: item,
                selected: item === _ctx.params.limit
              }, _toDisplayString(item), 9, _hoisted_29))
            }), 128))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_v_pagination, {
            modelValue: _ctx.params.page,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.page) = $event)),
              _ctx.onChangePage
            ],
            pages: _ctx.totalPages,
            "range-size": 1,
            "active-color": "#eee"
          }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
        ])
      ])
    ])
  ]))
}